import React from 'react';
import { StepperPage } from '.';
import { SnapButton } from '../SnapButton';

export default function Control({
  currentStepIndex,
  pages,
  onStepIndexChange,
  onLoadingChange,
  showSubmitForReviewButton,
}: {
  currentStepIndex: number;
  pages: StepperPage[];
  onStepIndexChange: (step: number) => void;
  onLoadingChange: (isLoading: boolean) => void;
  showSubmitForReviewButton?: boolean;
}): JSX.Element {
  const scrollToTop = (): void => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 250);
  };
  const changeStep = async (isForward: boolean): Promise<void> => {
    if (isForward && pages[currentStepIndex].beforeNext !== undefined) {
      onLoadingChange(true);
      await pages[currentStepIndex].beforeNext!();
    }
    const nextStep = currentStepIndex + (isForward ? 1 : -1);
    if (isForward && pages[currentStepIndex].beforeNext !== undefined) {
      onLoadingChange(false);
    }
    scrollToTop();
    onStepIndexChange(nextStep);
  };

  return (
    <div className='mt-4 mb-8 flex justify-end xs:justify-center md:justify-end'>
      <div
        className={`${
          showSubmitForReviewButton
            ? 'w-5/12 md:w-1/4 lg:w-1/4 pr-1'
            : 'w-7/12 md:w-1/4 lg:w-1/4 pl-1'
        }`}
      >
        {pages[currentStepIndex].navigation.showBack && (
          <SnapButton
            variant='tertiary'
            size='md'
            fullWidth
            onClick={(): Promise<void> => changeStep(false)}
            className='mb-2'
          >
            Back
          </SnapButton>
        )}
        {pages[currentStepIndex].navigation.onSkip !== undefined && (
          <SnapButton
            variant='tertiary'
            size='md'
            fullWidth
            onClick={(): void => pages[currentStepIndex].navigation.onSkip!()}
            className='mb-2'
          >
            Skip
          </SnapButton>
        )}
        {pages[currentStepIndex].onCancel !== undefined && (
          <SnapButton
            variant='tertiary'
            size='md'
            fullWidth
            onClick={(): void => pages[currentStepIndex].onCancel!()}
            className='mb-2'
          >
            Close
          </SnapButton>
        )}
      </div>
      {pages[currentStepIndex].navigation.showForward &&
        showSubmitForReviewButton && (
          <div className='w-7/12 md:w-1/4 lg:w-1/4 pl-1'>
            <SnapButton
              variant='primary'
              className='mb-2'
              size='md'
              fullWidth
              onClick={(): void => {
                if (pages[currentStepIndex].isValid) {
                  changeStep(true);
                }
              }}
              disabled={!pages[currentStepIndex].isValid}
            >
              {pages[currentStepIndex].nextText !== undefined
                ? pages[currentStepIndex].nextText
                : 'Next'}
            </SnapButton>
          </div>
        )}
      {pages[currentStepIndex].navigation.onFinish !== undefined && (
        <div className='w-7/12 md:w-1/4 lg:w-1/4 pl-1'>
          <SnapButton
            variant='primary'
            size='md'
            fullWidth
            onClick={(): void => pages[currentStepIndex].navigation.onFinish!()}
            className='mb-2'
            disabled={!pages[currentStepIndex].navigation.finishIsValid}
          >
            Finish
          </SnapButton>
        </div>
      )}
    </div>
  );
}
